import { VisualSlides } from './'
import { gsap } from "gsap";

class OpeningAnimation {
  constructor(el) {
    this.dom = { el: el };
    this.dom.target = this.dom.el.querySelector('[data-js="iam"]');

    this.init();
  }

  init() {
    const _this = this;
    this.scrollDisable();

    const start = (time) => {
      return new Promise((resolve, reject) => {
        setTimeout(()=>{
          document.body.dataset.opening = 'start';
          resolve();
        }, time);
      });
    }

    async function opening() {
      await start(300);

      const tl = gsap.timeline();
      tl.to(_this.dom.target, {
        opacity: 0,
        duration: 1.2,
        delay: .8,
        onComplete: () => {
          const domVisualSlides = document.querySelector('[data-js="visual"]');
          if (domVisualSlides) new VisualSlides(domVisualSlides);      
        }
      }).to(_this.dom.el, {
        opacity: 0,
        duration: 1.2,
        delay: .8,
        onComplete: () => {
          _this.dom.el.remove();
          document.body.removeAttribute('data-opening');
          _this.scrollEnable();
        }
      })
    }

    opening();
  }

	scrollDisable() {
    document.querySelector('html').dataset.isScrolldisable = 'true';
	}

	scrollEnable() {
    const _this = this;
    document.querySelector('html').removeAttribute('data-is-scrolldisable');
	}
}

export default OpeningAnimation